import FontBody2 from '../fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../fonts/font-props';
import IconInfo from '../icons/icon-info/icon-info';
import Icon from '../icons/icon/icon';
import { Tooltip } from '../tooltip/tooltip';
import './form-field.scss';

interface IFormFieldProps {
    label: React.ReactNode;
    children?: React.ReactNode;
    required?: boolean;
    tooltip?: React.ReactNode;
    instructions?: React.ReactNode;
}

export const FormField: React.FC<IFormFieldProps> = ({ label, children, required = false, tooltip, instructions }) => {
    return (
        <div className="form-field">
            <div className="form-field-title">
                <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                    {label}
                    {required && <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>}
                </FontBody2>
                {tooltip && <Tooltip content={tooltip}><Icon Component={IconInfo} /></Tooltip>}
            </div>

            {instructions && <FontBody2 color={FONT_COLOR.NEUTRAL3}>{ instructions }</FontBody2>}
            { children }
        </div>
    );
}
